import { Component, OnInit } from '@angular/core';
import {CompaniesService} from "./companies.service";
import {ExportService} from "../telecontact/export.service";
import {Chart} from "chart.js";
import 'chartjs-plugin-colorschemes';
import {NbDialogService, NbSidebarService} from "@nebular/theme";
import {DialogComponent} from "../helpers/dialog/dialog.component";
import {HcpComponent} from "../hcp/hcp.component";

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {


  public isLoading = false;
  public data = [];
  public labels = [];
  public raw = [];
  public render = {};
  public four = false;

  constructor( private companiesService: CompaniesService,
               private exportService: ExportService,
               private dialogService: NbDialogService,
               private sidebarService: NbSidebarService) { }

  ngOnInit() {

    Chart.defaults.global.plugins.colorschemes.scheme = 'tableau.Tableau10';

    console.log('init');


    //filters
    this.render['filter_hq'] = ['Maroc', 'France', 'US'];
    this.render['filter_hr'] = [];
    this.render['filter_tags'] = [];


    this.isLoading = true;
    this.companiesService.readAll().subscribe(res => {
      this.raw = res['data'].filter( d => d['date'] >= 2000);


      //columns
      this.render['countries'] = res['columns']['hq'];
      this.render['human_res'] = res['columns']['hr'];
      this.render['tags'] = res['columns']['tags'];

      let rr = [];
      this.render['tags'].map(e => rr = rr.concat( e.split(',')).map(e => e.trim())  );
      this.render['tags'] = Array.from(new Set(rr)).filter( e => e !== " " && e !== "").sort();

      //filters
      this.render['filter_hq'] = ['Maroc', 'France', 'US'];
      this.render['filter_hr'] = [];
      this.render['filter_tags'] = [];

      //rendered
      this.render['datatable'] = this.companiesService.filterBy(this.raw,  {'hq': this.render['filter_hq'], 'hr': this.render['filter_hr'], 'tags': this.render['filter_tags']});
      this.render['nbr_year'] = this.companiesService.numberByYear(this.render['datatable'], this.render['filter_hq'], this.four);
      this.render['nbr_hq'] = this.companiesService.numberByHq(this.render['datatable'], this.render['filter_hq']);
      this.render['hr_hq'] =  this.companiesService.numberByHr(this.render['datatable']);
      this.render['cap_hq'] =  this.companiesService.numberByCap(this.render['datatable']);


      this.getMarkers();

      this.isLoading = false;
    });
  }


  checked(ev, val, col) {
    if ( ev ) {

      if ( ! this.render[col].includes(val) ) {
        this.render[col].push(val);
        this.refAll();
      }

    } else {
      this.rmFilter(col, val);
      this.refAll();
    }


  }

  capitaliz(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  getMarkers(){
    let res = [];
    for(let e of this.render['datatable']){
      res.push({lat: Number(e['lat']), long: Number(e['lon'])});
    }
    //console.log(res);
    this.render['markers'] = res;
  }

  refCap() {
    //console.log(this.render['cap_ctr']);
    this.render['cap_hq'] = this.companiesService.numberByCap(this.render['datatable']);
  }

  refHr() {
    this.render['hr_hq'] = this.companiesService.numberByHr(this.render['datatable']);
  }

  refYear(){
    this.render['nbr_hq'] = this.companiesService.numberByHq(this.render['datatable'], this.render['filter_hq']);
    this.render['nbr_year'] = this.companiesService.numberByYear(this.render['datatable'], this.render['filter_hq'], this.four);
  }

  refTable(){
    //this.render['markers'] = this.render['datatable'].map(loc => this.geoService.geoCoder(loc.location) );
    this.render['datatable'] = this.companiesService.filterBy(this.raw,  {'hq': this.render['filter_hq'], 'hr': this.render['filter_hr'], 'tags': this.render['filter_tags']});
  }


  rmFilter(col, val){
    this.render[col] = this.render[col].filter(d => d !== val);
  }


  refAll() {
    this.refTable();
    this.refCap();
    this.refHr();
    this.refYear();
  }

  exportAsXLSX():void {
    this.exportService.exportAsExcelFile(this.render['datatable'], 'sample');
  }


  openInfo(){
    this.dialogService.open(DialogComponent, {context: {
        title: 'Competition Analysis: Big Data case study',
        desc: 'Assume an entrepreneur interested in offering big data and artificial intelligence (AI) services in ' +
          'Morocco. They are confronted with the task of analyzing the competition, which could be a cumbersome task. ' +
          'Here, we collect, process and merge data from various sources including online directories, social media, ' +
          'press, companies’ websites and incubators’ websites in order to identify companies that provide big data and ' +
          'AI services in Morocco and analyze their characteristics including size, sector, capital, creation date, ' +
          'headquarters, description and services. Such work can be replicated for other sectors.',
    }});
  }

  toggle() {
    this.sidebarService.toggle(false, 'left');
  }

}
